import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import {
  Modal,
  Paper,
  PaperHeadline,
  PaperContent,
  Button,
} from '../..'

export class PetBestContentModal extends React.PureComponent {
	static propTypes = {
		open: PropTypes.bool,
		onClose: PropTypes.func,
    modalHeadline: PropTypes.string,
    html: PropTypes.any,
    cancelButtonProps: PropTypes.shape({
      id: PropTypes.string,
      size: PropTypes.string,
      onClick: PropTypes.func
    }),
  }

  render() {
    const {
      open,
      onClose,
      modalHeadline,
      html,
      cancelButtonProps
    } = this.props


    return (
      <Modal open={open} onClose={onClose}>
        <div className='ui-petbest-content-modal'>
          <Paper type={Paper.Types.framed}>
            <PaperHeadline>{modalHeadline}</PaperHeadline>
            <PaperContent>
              <div dangerouslySetInnerHTML={{ __html: html }}></div>
              <div className='ui-petbest-content-modal__actions'>
                <Button
                  type='button'
                  size={Button.Sizes.small}
                  color={Button.Colors.tertiary}
                  {...cancelButtonProps}
                >
                  Close
                </Button>
              </div>
            </PaperContent>
          </Paper>
        </div>
      </Modal>
    )
  }
}